import { resBreak } from "@/utils/resBreak"
import { SxProps } from "@mui/material"

export const sidebarAppBarContainerSXP:SxProps = {
    bgcolor: resBreak<'backgroundColor'>({mobile: 'navbar.primary', tablet:'inherit', desktop:'inherit'}), 
    color:'#000'
}

export const sidebarAppBarContentSXP:SxProps = {
    color:'#000'
}

export const sidebarAccordionSummarySXP:SxProps = {
    bgcolor: resBreak<'backgroundColor'>({mobile:'navbar.primary',desktop:'inherit', tablet:'inherit'}),
	color: '#000',
    '& h2':{
        fontSize:16,
        fontWeight:'bold'
    }
}


export const sidebarNavigationFilterHR:SxProps = {
    fontSize: 25,
	fontWeight: 400,
	'@media (max-width:600px)': {   
     	fontSize: 18, 
    }, 
}
